module.exports = __webpack_public_path__ + "static/media/ab1.5979d3ef.jpg";